<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading" style="position: fixed; top: 0; left: 0; width: 100%;height: 100%;    z-index:99;">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row">
    <div class="col-12">
      <div style="margin-top:10px; margin-bottom:-10px;">
        <h4><span style="padding-right:15px"></span><i class="fa fa-list" aria-hidden="true"></i> <b>Correspondence Batches</b></h4>
      </div>
    </div> 
  </div>
  <hr> 

  <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
    <legend class="scheduler-border tsk-display">Correspondence Batches</legend>
    <div class="row" style="margin:4px auto!important;padding:0px">
      <div class="col-12" style="margin:0px!important;padding:0px!important;">
        <table class="table tbl-stl table-sm" border="1" style="width:100%;">
          <thead class="thead-inverse">
            <tr class="hd-clpse">
              <th style="" class="tbl-hd-stl">Date/time started</th>
              <th class="tbl-hd-stl">Date/time completed</th>
              <th class="tbl-hd-stl" style="width:12%!important;">#Emails sent</th>
              <th class="tbl-hd-stl" style="width:12%!important;">#SMS sent</th>
            </tr>
          </thead>
          <tbody>
            <tr class="tbl-row click hov" *ngFor="let item of batches | paginate: {itemsPerPage:pageSize, currentPage: utility.page ,totalItems: count}">
              <td class="bfr-end-col">{{item.date_created | date:'y/MM/dd HH:mm:ss'}}</td>
              <td class="bfr-end-col">{{item.date_modified | date:'y/MM/dd HH:mm:ss'}}</td>
              <td class="bfr-end-col">{{item.num_emails_sent}}</td>
              <td class="bfr-end-col end-col">{{item.num_sms_sent}}</td>
            </tr>
          </tbody>
          <tfoot style="padding:0px;margin:0px;">
            <tr  style="padding-left:0px;margin-left:0px;">
              <td colspan="3" class="rm-brd" style="padding-left:0px;margin-left:0px;">
                <div class="row" *ngIf="count > 1">
                  <div class="col-2">
                    <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                      <div class="input-group-prepend">
                        <label class="input-group-text form-control-sm show-h" for="show-id" style="">Show:</label>
                      </div>
                      <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize" (change)="onChange()">
                        <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-8 text-center">
                    <pagination-controls (pageChange)="utility.page = onNextOrPrevious($event)" style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                  </div>
                </div>
              </td>
              <td style="vertical-align:top!important;width:12%!important;" class="rm-brd">
                <div class="cover-x pull-right">
                  <div class="main-btn rounded-circle rmp-all" (click)="closeBatches()" title="Close" style="margin: 0px auto!important;" rel="tooltip" data-placement="top">
                    <span class="fa fa-times fa-2x" style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
                  </div>
                  <div class="lbl-app" style="margin: 1px auto;">
                    <span>Close</span>
                  </div>
                </div>
                <div class="cover-x">
                  <div class="main-btn rounded-circle rmp-all" (click)="send()" title="Send Correspondences" style="margin: 0px auto!important;" rel="tooltip" data-placement="top">
                    <span class="fa fa-share-square-o fa-2x" style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
                  </div>
                  <div class="lbl-app" style="margin: 1px auto;">
                    <span>Send</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="isEmpty" style="">
              <td colspan="4" class="rm-brd">
                <span class="text-info text-small">No Correspondence Logs found.</span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>    
  </fieldset>  
</div>
